export default __webpack_public_path__ + "static/media/selectedinactivebell.d064af84.svg";